import React, { memo } from 'react';
import { Wrapper, Title, Subheader, Supheader } from './components';
import { purify } from '../../utils/helpers';

type HeaderPropTypes = {
  text: string;
  supheader?: string;
  subheader?: string;
  textAlign?: React.CSSProperties['textAlign'];
  disableEndMargin?: boolean;
  className?: string;
  headerColor?: string;
  subheaderColor?: string;
  usePrimaryHeading?: boolean;
};

function Header({
  text,
  supheader,
  subheader,
  textAlign = 'center',
  disableEndMargin = false,
  className,
  headerColor,
  subheaderColor,
  usePrimaryHeading,
}: HeaderPropTypes) {
  return (
    <Wrapper
      className={className}
      textAlign={textAlign}
      disableEndMargin={disableEndMargin}
    >
      {supheader && (
        <Supheader
          dangerouslySetInnerHTML={{
            __html: purify(supheader),
          }}
        />
      )}
      <Title
        as={usePrimaryHeading ? 'h1' : 'h2'}
        color={headerColor}
        dangerouslySetInnerHTML={{ __html: purify(text) }}
      />
      {subheader && (
        <Subheader
          as={usePrimaryHeading ? 'h2' : 'h3'}
          color={subheaderColor}
          dangerouslySetInnerHTML={{
            __html: purify(subheader),
          }}
        />
      )}
    </Wrapper>
  );
}

export default memo(Header);
